<template>
  <b-modal id="bv-modal-categories">
    <template #modal-header>
      <h4>{{ data.id ? $t("edit_category") : $t("create_category") }}</h4>
      <b-button
        size="sm"
        variant="outline-light"
        class="ml-auto"
        @click="$bvModal.hide('bv-modal-categories')"
      >
        <i class="fas fa-times"></i> 
      </b-button>
    </template>

    <div>
      <form @submit.prevent>
        <div class="row justify-content-center">
          <div class="col-md-6">
            <a href="#" id="pick-image" class="box">
              <img
                style="max-height: 218px; max-width: 218px"
                :src="preview"
                alt="Users"
              />
              <div class="text-center table-text" v-if="fileSelected">
                {{ $t("selection") }}:
                <b>{{ fileSelected ? fileSelected.name.substr(0, 24) : "" }}</b>
              </div>
              <div class="text-center table-text" v-else>
                {{ $t("selected-image") }}
              </div>
            </a>
          </div>
          <div class="col-md-12">
            <base-input
              :label="$t('name')"
              :placeholder="$t('name')"
              input-classes="form-control-alternative border"
              v-model="data.name"
              data-vv-validate-on="blur"
              v-validate="'required'"
              :data-vv-as="$t('name')"
              name="name"
              autocomplete="off"
            />
            <span class="text-danger text-sm" v-show="errors.has('name')"
              ><small>{{ errors.first("name") }}</small></span
            >
          </div>
          <div class="col-md-12">
            <base-input alternative="" :label="$t('description')">
              <textarea
                rows="4"
                v-model="data.description"
                class="form-control form-control-alternative border"
                :placeholder="$t('description')"
                autocomplete="off"
                name="description"
              />
            </base-input>
          </div>
          <div class="col-md-12 mt-2">
            <avatar-cropper
              :upload-handler="selectedFile"
              @changed="setFileName"
              trigger="#pick-image"
              :labels="{
                submit: $t('accept'),
                cancel: $t('cancel'),
              }"
              :cropper-options="{
                aspectRatio: 1,
                autoCropArea: 1,
                viewMode: 1,
                movable: false,
                zoomable: false,
              }"
            />
          </div>
        </div>
      </form>
    </div>

    <template #modal-footer>
      <b-button size="sm" variant="primary" @click="add">
        {{ $t("save") }}
      </b-button>
      <b-button
        size="sm"
        variant="secondary"
        @click="$bvModal.hide('bv-modal-categories')"
      >
        {{ $t("close") }}
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import AvatarCropper from "vue-avatar-cropper";
import helpers from "@/services/helpers";
import { mapActions } from "vuex";
import { myRendeImage } from "@/directives/render-Image";
export default {
  mixins: [myRendeImage],
  components: {
    AvatarCropper,
  },
  data() {
    return {
      data: {
        id: null,
        name: "",
        description: "",
        picture: null,
        company_id: null,
      },
      preview: null,
      fileSelected: null,
    };
  },
  methods: {
    ...mapActions({
      createCategory: "category/createOrUpdate",
    }),
    showModal(item) {
      this.data = {
        id: null,
        name: "",
        description: "",
        picture: null,
        company_id: item.company,
      };
      this.fileSelected = null
      this.preview = require("@/assets/img/brand/no-image.jpg");
      if (item.data) {
        this.data = {
          id: item.data.id,
          name: item.data.name,
          description: item.data.description,
          company_id: item.company,
        };
        this.preview = this.imageData(item.data.picture);
      }
      this.$bvModal.show("bv-modal-categories");
    },
    filesChange(files) {
      this.data.picture = files;
    },
    setFileName(file) {
      this.fileSelected = file;
      this.data.picture = file;
    },
    selectedFile(cropper) {
      const dataUrl = cropper
        .getCroppedCanvas()
        .toDataURL(this.fileSelected.type);
      const file = helpers.dataURLtoFile(dataUrl, this.fileSelected.name);
      this.preview = dataUrl;
      this.data.picture = file;
    },
    async add() {
      if (this.data.id) {
        try {
          const validation = await this.$validator.validateAll();
          if (validation) {
            const data = new FormData();
            data.append("name", this.data.name);
            data.append("description", this.data.description);
            data.append("picture", this.data.picture);
            data.append("company_id", this.data.company_id);
            data.append("_method", "PUT");
            const res = await this.createCategory({
              id: this.data.id,
              company: this.data.company_id,
              data: data,
            });
            this.$toast.success(res.message, {
              position: "top-right",
            });
            this.$bvModal.hide("bv-modal-categories");
          }
        } catch (error) {
          console.log(error);
        }
      } else {
        try {
          const validation = await this.$validator.validateAll();
          if (validation) {
            const data = new FormData();
            data.append("name", this.data.name);
            data.append("description", this.data.description);
            data.append("picture", this.data.picture);
            data.append("company_id", this.$route.params.id);
            const res = await this.createCategory(data);
            this.$toast.success(res.message, {
              position: "top-right",
            });
            this.$bvModal.hide("bv-modal-categories");
          }
        } catch (error) {
          console.log(error);
        }
      }
    },
  },
};
</script>

<style></style>
